import { render } from "./OverviewBox.vue?vue&type=template&id=f52c5e16"
const script = {}

import "./OverviewBox.vue?vue&type=style&index=0&id=f52c5e16&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__